import { render, staticRenderFns } from "./ns-order-refund.vue?vue&type=template&id=35816b7e&"
import script from "./ns-order-refund.vue?vue&type=script&lang=js&"
export * from "./ns-order-refund.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports